import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Saves one owner's split of a Profit Distribution, replacing any earlier one
export const saveFundAllocation = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/profit_distribution/saveFundAllocation`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
